export default [
	{
		path: '/app/dashboard',
		component: () => import('../../../layouts/MainLayout.vue'), // 使用するレイアウトの選択
		children: [
			{
				path: '', // 親と同じpathで表示するコンポーネントを下記で指定
				name: 'dashboard',
				component: () => import(/* webpackChunkName: "dashboard" */ '../../../components/dashboard/DashboardView'),
				meta: { title:'YubiOn SecureFileTransfer | Dashboard'}
			},
		]
	}
]
